import { motion } from 'framer-motion';
import { Star, ExternalLink, ChevronLeft, ChevronRight } from 'lucide-react';
import { useState, useCallback, useEffect } from 'react';

const reviews = [
  {
    name: 'Nath Nathy',
    initial: 'N',
    location: 'Sevran',
    text: "Institut au top mais avec Carine il était sur de retrouver une ambiance professionnelle et chaleureuse. Je recommande vivement. Merci pour les sourcils et la teinture.",
    rating: 5,
    service: 'Épilation cire sourcils',
  },
  {
    name: 'Lily Kay',
    initial: 'L',
    location: 'Sevran',
    text: "Merci à Carine de nous donner l'opportunité de s'embellir, avoir accès a des soins très bien réalisés et durable! Merci pour tout c'est un lieux que je recommande vivement.",
    rating: 5,
    service: 'HIFU visage',
  },
  {
    name: 'Maryse Christine',
    initial: 'M',
    location: 'Sevran',
    text: "Une professionnelle a notre écoute bravo à cette infirmière qui aujourd'hui décidé de s attaquer a la médecine esthétique de qualité. Je recommande l'expérience !",
    rating: 5,
    service: 'Électro-Mésothérapie',
  },
  {
    name: 'Sel Dersîm',
    initial: 'S',
    location: 'Sevran',
    text: "Institut incroyable sur tous les soins que j'ai effectué tous étaient efficaces. Sans parler de l'accueil qui est toujours parfait! Les prix sont abordables.",
    rating: 5,
    service: 'E-SLIM Cryo 360°',
  },
  {
    name: 'Fella Ouahrani',
    initial: 'F',
    location: 'Sevran',
    text: "Super expérience. Corinne est à l'écoute et attentive. Mon soin s'est très bien passé. Merci bp.",
    rating: 5,
    service: 'Hydrafacial',
  },
  {
    name: 'Corinne Chansigaud',
    initial: 'C',
    location: 'Sevran',
    text: "Salon très agréable avec une professionnelle au top. Carine je recommande 100 pour 100.",
    rating: 5,
    service: 'Hightechskin anti-âge',
  },
];

const MAPS_REVIEWS_LINK = 'https://maps.app.goo.gl/MYjhdAwtngvYopSZ9';

const ReviewsSection = () => {
  const [perPage, setPerPage] = useState(3);
  const totalPages = Math.ceil(reviews.length / perPage);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      setPerPage(w < 640 ? 1 : w < 1024 ? 2 : 3);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  useEffect(() => {
    if (page >= totalPages) setPage(0);
  }, [perPage, totalPages, page]);

  const prev = useCallback(() => setPage((p) => (p - 1 + totalPages) % totalPages), [totalPages]);
  const next = useCallback(() => setPage((p) => (p + 1) % totalPages), [totalPages]);

  const visible = reviews.slice(page * perPage, page * perPage + perPage);

  return (
    <section className="px-6 lg:px-8 py-16 md:py-20 bg-secondary/30">
      <div className="mx-auto max-w-6xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-2 text-center font-heading text-2xl font-bold text-foreground md:text-3xl"
        >
          Ce que disent nos clientes
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12 text-center text-sm text-muted-foreground"
        >
          8 avis Google · Note 4.5/5
        </motion.p>

        <div className="relative flex items-center">
          <button
            onClick={prev}
            className="absolute -left-4 z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-border bg-card shadow-sm transition-colors hover:bg-secondary md:-left-14"
            aria-label="Avis précédents"
          >
            <ChevronLeft size={20} className="text-muted-foreground" />
          </button>

          <div className="mx-auto grid w-full grid-cols-1 gap-6 px-8 sm:grid-cols-2 lg:grid-cols-3 md:px-0">
            {visible.map((review, i) => (
              <motion.div
                key={`${page}-${i}`}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08 }}
                className="flex flex-col rounded-2xl border border-border bg-card p-7 shadow-sm"
              >
                <div className="mb-4 flex gap-0.5">
                  {Array.from({ length: review.rating }).map((_, j) => (
                    <Star key={j} size={18} className="fill-accent text-accent" />
                  ))}
                </div>
                <p className="flex-1 text-sm italic leading-relaxed text-foreground/80">
                  "{review.text}"
                </p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/15 text-sm font-semibold text-primary">
                    {review.initial}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground">{review.name}</p>
                    <p className="text-xs text-muted-foreground">{review.service} · {review.location}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <button
            onClick={next}
            className="absolute -right-4 z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-border bg-card shadow-sm transition-colors hover:bg-secondary md:-right-14"
            aria-label="Avis suivants"
          >
            <ChevronRight size={20} className="text-muted-foreground" />
          </button>
        </div>

        <div className="mt-8 flex justify-center gap-0">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              onClick={() => setPage(i)}
              className="h-6 w-6 rounded-full transition-all flex items-center justify-center"
              aria-label={`Page ${i + 1}`}
            >
              <span className={`block h-2 w-2 rounded-full transition-all ${
                i === page ? 'bg-primary scale-110' : 'bg-border'
              }`} />
            </button>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-10 flex justify-center"
        >
          <a
            href={MAPS_REVIEWS_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 rounded-full border-2 border-primary/30 bg-card px-5 py-3 text-xs sm:text-sm font-medium text-foreground transition-all hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10 whitespace-nowrap"
          >
            <ExternalLink size={16} className="text-primary" />
            Voir tous les avis sur Google (8 avis ⭐ 4.5/5)
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ReviewsSection;
